import React, { PureComponent } from 'react';
import Formulario from './formulario';
import { Slide } from "react-awesome-reveal";

export default class Contacto extends PureComponent {
  render() {
    return (
      <section className="review">
        <section className="contacto">
        <Slide direction="left">
        <div className="section__container review__container" id="contacto" style={{ scrollMarginTop: '130px' }}>
          <div className="review__content">
          <h2 style={{ color: 'black' }}><span style={{color:'orange'}}>CONTACTA</span> CON NOSOTROS</h2>
            <Formulario />
          </div>
        </div>
        </Slide>
        </section>
      </section>
    );
  }
}